import { Typography } from '@forethought-technologies/forethought-elements';
import { Box, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks';
import { selectIntroConfig } from 'reducers/config';

export const Intro = () => {
  const theme = useTheme();
  const introConfig = useAppSelector(selectIntroConfig);
  // check that at least one intro config is enabled and populated
  const isIntroEnabled = Object.values(introConfig).some(
    config => config.enabled && config.value,
  );

  if (!isIntroEnabled) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        paddingX: '8px',
        paddingY: '16px',
        textAlign: 'center',
      }}
    >
      {introConfig.image.enabled && introConfig.image.value && (
        <Box sx={{ display: 'block' }}>
          <Box
            alt=''
            component='img'
            src={introConfig.image.value}
            sx={{ height: '64px', width: 'auto' }}
          />
        </Box>
      )}
      {introConfig.title.enabled && introConfig.title.value && (
        <Typography variant='font20'>{introConfig.title.value}</Typography>
      )}
      {introConfig.subtitle.enabled && introConfig.subtitle.value && (
        <Typography color={theme.palette.colors.grey[600]} variant='font14'>
          {introConfig.subtitle.value}
        </Typography>
      )}
    </Box>
  );
};
